/* RayoCommerce OS — comportamiento propio de la Landing de Mini Impresora PrintyCat.
   Namespace rc-pc-* — no modifica rc-scripts.js compartido. */
(function () {
  function initSticky() {
    var bar = document.querySelector('[data-rc-pc-sticky]');
    var trigger = document.querySelector('[data-rc-pc-sticky-trigger]');
    if (!bar || !trigger || !('IntersectionObserver' in window)) return;

    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          bar.classList.toggle('is-rc-pc-visible', !entry.isIntersecting);
          // Propaga la visibilidad de la barra a <body> para que otros widgets fixed
          // (p. ej. el chat-bubble de WhatsApp) puedan reaccionar vía CSS y no colisionar.
          document.body.classList.toggle('rc-pc-cta-lifted', !entry.isIntersecting);
        });
      },
      { threshold: 0 }
    );
    observer.observe(trigger);
  }

  function initScrollTo() {
    var links = document.querySelectorAll('[data-rc-pc-scrollto]');
    links.forEach(function (link) {
      link.addEventListener('click', function (e) {
        e.preventDefault();
        var target = document.querySelector(link.getAttribute('data-rc-pc-scrollto'));
        if (target) target.scrollIntoView({ behavior: 'smooth', block: 'start' });
      });
    });
  }

  function initGaleria() {
    document.querySelectorAll('[data-rc-pc-galeria]').forEach(function (galeria) {
      var main = galeria.querySelector('[data-rc-pc-galeria-main]');
      var thumbs = galeria.querySelectorAll('[data-rc-pc-galeria-thumb]');
      if (!main || !thumbs.length) return;
      thumbs.forEach(function (thumb) {
        thumb.addEventListener('click', function () {
          var full = thumb.getAttribute('data-full');
          if (full) main.setAttribute('src', full);
          thumbs.forEach(function (t) { t.classList.remove('is-active'); });
          thumb.classList.add('is-active');
        });
      });
    });
  }

  function initBuy() {
    var triggers = document.querySelectorAll('[data-rc-pc-buy]');
    if (!triggers.length) return;
    triggers.forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        // Dispara el botón real de Releasit (abre el formulario COD ya poblado).
        var rel = document.querySelector('#_rsi-buy-now-button, ._rsi-buy-now-button');
        if (rel) { rel.click(); return; }
        // Respaldo: llevar al bloque de compra donde vive el botón de Releasit.
        var box = document.querySelector('[id^="shopify-section"][id$="__main"], #shopify-section-main');
        if (box) box.scrollIntoView({ behavior: 'smooth', block: 'center' });
      });
    });
  }

  function init() {
    initSticky();
    initScrollTo();
    initGaleria();
    initBuy();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
